const WorkOrders = () => import("Modules/work_orders/views/WorkOrders");
const WorkOrdersForm = () => import("Modules/work_orders/views/WorkOrdersForm");

export default {
    children: [
        {
            path: "work_orders",
            name: "work_orders",
            component: WorkOrders,
            meta: {
                requiresAuth: true,
                title: "lang.work_orders",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer", "d_acct_mgr", "distributor"],
                restrict_by_permission: ["work_orders.read"],
            },
        },
        {
            path: "work_order/:id?",
            name: "work_order",
            component: WorkOrdersForm,
            meta: {
                requiresAuth: true,
                title: "lang.work_orders",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer", "d_acct_mgr", "distributor"],
                restrict_by_permission: ["work_orders.read"],
            },
        },
    ],
};
